import React from "react";
import ProductPage from "../../components/ProductPages/ProductPage";
import {
  generateBreadcrumbStructuredData,
  generateWebPageStructuredData,
} from "../../components/SEO/StructuredData";

const DESCRIPTION =
  "Stop handwriting checks late at night. Export checks from locked payout amounts so the PDF matches the board. Included on Free.";

const SECTIONS = [
  {
    title: "Handwriting checks after a long day",
    body: "The board is locked and you still have a stack of blank checks. Writing each amount by hand invites mistakes and keeps you at the desk after everyone else leaves.",
  },
  {
    title: "Amounts come from the locked payouts",
    body: "After you lock payouts, Export Checks builds a PDF from those same amounts. The checks match what bowlers see on the prize list. This is included on Free.",
  },
  {
    title: "Line the template up with your stock",
    body: "Set a check template once for your organization. Line fields up with the stock you print on. Choose one check per prize or one check per bowler.",
  },
  {
    title: "Print at actual size",
    body: "Print the PDF on 8.5 × 11 stock at actual size. Do not fit to page. That keeps the amounts on the right lines.",
  },
];

const BowlingTournamentCheckExports = () => (
  <ProductPage
    title="Export bowling tournament checks | Bowling Tournament App"
    description={DESCRIPTION}
    keywords={[
      "bowling tournament check printing",
      "export checks",
      "prize checks",
    ]}
    canonicalUrl="/bowling-tournament-check-exports"
    heading="Stop handwriting checks late at night"
    lede="Export checks from the locked payout amounts so the PDF matches the board. Included on Free."
    analyticsLocation="product_check_exports"
    sectionHeading="From locked payouts to printed checks"
    sections={SECTIONS}
    secondaryTo="/bowling-tournament-payouts"
    secondaryLabel="Payouts"
    structuredData={generateWebPageStructuredData({
      name: "Export bowling tournament checks",
      description: DESCRIPTION,
      url: "/bowling-tournament-check-exports",
      dateModified: "2026-10-31",
    })}
    additionalStructuredData={[
      generateBreadcrumbStructuredData([
        { label: "Home", path: "/" },
        { label: "Payouts", path: "/bowling-tournament-payouts" },
        {
          label: "Check exports",
          path: "/bowling-tournament-check-exports",
        },
      ]),
    ]}
  />
);

export default BowlingTournamentCheckExports;
